const asDate = (date: Date | string) => {
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString();
}

const asTime = (date: Date | string) => {
  const dateObj = new Date(date);

  // time will be formatted as 12-hour time with AM/PM without seconds

  return dateObj.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
}

const asDateTime = (date: Date | string) => {
  // date will be formatted as MM/DD/YYYY
  // time will be formatted as 12-hour time with AM/PM without seconds
  return `${asDate(date)} ${asTime(date)}`;
}

/**
 * Formats a date for use as startDateRange in API calls.
 * Returns date-only string (YYYY-MM-DD) without time or timezone.
 */
const formatStartDateRange = (date: Date | string | null | undefined): string | null => {
  if (!date) return null;
  const dateObj = new Date(date);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Formats a date for use as endDateRange in API calls.
 * Returns date-only string (YYYY-MM-DD) without time or timezone.
 */
const formatEndDateRange = (date: Date | string | null | undefined): string | null => {
  if (!date) return null;
  const dateObj = new Date(date);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Formats a date to YYYY-MM-DD string format (for date-only APIs).
 */
const formatDateOnly = (date: Date | string | null | undefined): string | null => {
  if (!date) return null;
  const dateObj = new Date(date);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const formatDate = {
  asDate,
  asTime,
  asDateTime,
  formatStartDateRange,
  formatEndDateRange,
  formatDateOnly,
};
